module.exports = __webpack_public_path__ + "static/img/3-7.2ad39d70.png";